import { render, staticRenderFns } from "./PurchaseOrderSublet.vue?vue&type=template&id=512115c8&scoped=true"
import script from "./PurchaseOrderSublet.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderSublet.vue?vue&type=script&lang=js"
import style0 from "./PurchaseOrderSublet.vue?vue&type=style&index=0&id=512115c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512115c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('512115c8')) {
      api.createRecord('512115c8', component.options)
    } else {
      api.reload('512115c8', component.options)
    }
    module.hot.accept("./PurchaseOrderSublet.vue?vue&type=template&id=512115c8&scoped=true", function () {
      api.rerender('512115c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/PurchaseOrderSublet.vue"
export default component.exports